/**
 * @param {string} key
 * @param {any} data
 * @returns {void}
 */
export const setSessionItem = (key, data) => {
    if (typeof Storage !== 'undefined') {
        window.sessionStorage.setItem(key, JSON.stringify(data));
    }
};

/**
 * @param {string} key
 * @return {string | null}
 */
export const getSessionItem = (key) => {
    if (typeof Storage !== 'undefined') {
        let value = window.sessionStorage.getItem(key);
        try {
            value = JSON.parse(value);
        } catch (error) {}
        return value;
    }
};

/**
 * @param {string} key
 * @return {void}
 */
export const removeSessionItem = (key) => {
    if (typeof Storage !== 'undefined') {
        window.sessionStorage.removeItem(key);
    }
};
